import { useState } from 'react';
import { ProductData } from '@/types/Productdata.interfacew.ts';
import { StockItem } from '@/types/StockItem.interface.ts';
import { Loader } from 'lucide-react';
import { cartTwoIcon } from '../../assets/icons/icons';
import { useScreenDetector } from '@/hooks/useScreenDetector.ts';
import { ImgCarousel } from '../ImgCarousel/ImgCarousel';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store';
import { addToCartPublisher } from '@/utils/storage/extra/loaders/cart/addToCartPublisher';

const DOMAIN = 'https://podzamenu.ru';//TODO убрать на проде

interface Props {
    stockItemData: StockItem,
    productData: ProductData,
}

/**
 * Карточка акционного товара
 * @param param
 * @returns
 */
export const ProductStockCard: React.FC<Props> = ({
    stockItemData,
    productData,
}) => {
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId as number);
    const dispatch = useAppDispatch();
    const [showCarousel, setShowCarousel] = useState(false);
    const [isImgLoaded, setIsImgLoaded] = useState(false);

    const { isMobile } = useScreenDetector();

    /** Показывает карусель изображений дефектного товара */
    const handleShowCarousel = () => {
        setShowCarousel(true);
    };

    return (
        <div className='bg-[#fafbfc] rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-stretch shadow-md'>
            <div className='w-full sm:w-40 flex-shrink-0 flex items-center justify-center mb-4 sm:mb-0'>
                {!isImgLoaded && <Loader className='w-8 h-8 animate-spin text-orange-500' />}
                <img src={DOMAIN + stockItemData.defectImages[0].url}
                    onClick={handleShowCarousel}
                    onLoad={() => setIsImgLoaded(true)}
                    className={isImgLoaded ? 'w-full max-w-[160px] h-[120px] sm:h-[160px] object-cover rounded-2xl cursor-pointer transition-transform hover:scale-105 shadow-lg' : ''}
                    alt={productData.name} />
            </div>
            <div className='w-full sm:w-48 flex flex-col justify-center pl-0 sm:pl-4 mb-4 sm:mb-0'>
                <p className='font-bold text-base'>{productData.brand}</p>
                <a className="text-[#F39200] underline font-bold"
                    href={`/spares/${productData.brandSlug}/${productData.article}`}>
                    {productData.article}
                </a>
                <p className="font-bold mb-1">{productData.name} (уценёнка)</p>
                <p className='text-sm text-gray-700 mb-2'>{stockItemData.defectDescription}</p>
            </div>
            <div className="flex-1 sm:pl-8 flex flex-col justify-start">
                <div className="flex items-center border-b border-gray-200 font-semibold text-base mb-2 mt-0">
                    <p className="w-1/2 flex items-center">
                        <span className="font-normal text-sm">Наличие</span>
                    </p>
                    <p className="w-1/4 flex items-center justify-center">
                        <span>Цена</span>
                    </p>
                </div>
                <div className="flex items-center py-2 border-b border-gray-200 last:border-b-0">
                    <p className="w-1/2 text-base">В наличии</p>
                    <p className="w-1/4 font-bold text-center text-lg">{stockItemData.price}</p>
                    <div className="w-1/4 flex justify-end">
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 bg-[#F39200] hover:bg-orange-500 rounded-lg px-6 py-1 text-base font-bold text-white"
                            onClick={() => dispatch(addToCartPublisher({ cartId, itemId: stockItemData.id }))}>
                            {!isMobile && <>В корзину</>}
                            {isMobile && <img src={cartTwoIcon} alt='В корзину' />}
                        </button>
                    </div>
                </div>
            </div>
            {showCarousel && <ImgCarousel images={stockItemData.defectImages}
                showCarousel={showCarousel}
                setShowCarousel={setShowCarousel}
                domain={DOMAIN} />}
        </div>
    )
}
